<template>

 <form  data-vv-scope="newinvitepetitionerform"  @submit.prevent>
          <div class="form-container">
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="form_group">
              <label class="form_label">Company Name<em>*</em></label>
                  <vs-input :key="'companyname'" @click="formerrors.msg=''" type="text" class="w-full no-icon-border" name="companyname" data-vv-as="Company Name" v-model="newPetitioner.name" v-validate="'required'" />
                  <span class="text-danger text-sm" v-show="errors.has('newinvitepetitionerform.companyname')">{{ errors.first("newinvitepetitionerform.companyname") }}</span>
                </div>
              </div>
              
              <div class="vx-col w-1/2">
                <div class="form_group">
                  <label class="form_label">First Name<em>*</em></label>
                  <vs-input :key="'adminFirstName'" type="text" class="w-full no-icon-border" name="adminFirstName" data-vv-as="First Name" v-model="newPetitioner.adminFirstName" v-validate="'required'" />
                    <span class="text-danger text-sm" v-show="errors.has('newinvitepetitionerform.adminFirstName')">{{ errors.first("newinvitepetitionerform.adminFirstName") }}</span>
                </div>
              </div>
              <div class="vx-col w-1/2">
              <div class="form_group">
                  <label class="form_label"> Last Name<em>*</em></label>
                  <vs-input :key="'adminLastName'" type="text" class="w-full no-icon-border" name="adminLastName" data-vv-as="Last Name" v-model="newPetitioner.adminLastName" v-validate="'required'" />
                  <span class="text-danger text-sm" v-show="errors.has('newinvitepetitionerform.adminLastName')">{{ errors.first("newinvitepetitionerform.adminLastName") }}</span>
                </div>
              
              </div>
              
              <div class="vx-col w-1/2">
                  <div class="form_group">
                  <label class="form_label">Email ID<em>*</em></label>
                  <vs-input v-model="newPetitioner.email" class="w-full no-icon-border" :key="'email'" name="email" data-vv-as="Email" autocomplete="off" autocorrect="off" autocapitalize="none" v-validate="'required|email'" />
                  <span class="text-danger text-sm" v-show="errors.has('newinvitepetitionerform.email')">{{ errors.first("newinvitepetitionerform.email") }}</span>
                  </div>
                </div>
                <div class="vx-col w-1/2"  @click="formerrors.msg=''">
                <div class="form_group ph_number">
                <div class="vs-component">
                <label for="" class="form_label">Phone Number<em>*</em></label>
                <VuePhoneNumberInput
                  autocomplete="off" 
                  autocorrect="off"
                  icon-pack="feather"
                  class="w-full no-icon-border"
                  :no-example="false"
                  v-validate="'required'"
                  data-vv-as="Phone Number"
                  name="phone"
                  v-bind="vuePhone.props"
                  default-country-code="US"
                  placeholder="Number"
                  :no-country-selector="false"
                  v-model="newPetitioner.phone"
                    @update="updatePetitionerPhone"
                    :preferred-countries="['US', 'IN']"
                  /> 
                  <span class="text-danger text-sm"   v-show="!isPetitionerPhoneValid && !errors.has('newinvitepetitionerform.phone')" >*Invalid phone number - Please enter a valid one</span>
                <span class="text-danger text-sm" v-show="errors.has('newinvitepetitionerform.phone')">{{ errors.first("newinvitepetitionerform.phone") }}</span>
                </div>      
                </div>     
              </div>
            
            </div>
            <template v-if="checkProperty(branchList, 'length')>1 && false">
              <div class="custom-radio_wrap wf_radio"  v-if="[3].indexOf(getUserRoleId)>-1">
                <ul class="custom-radio mt-0 ml-0" >
                  <li> 
                    <vs-radio name="defaultBranch" @input="branchChanges(false)" :vs-value="false" v-model="custBranchType" class="w-full" >Assign Branch</vs-radio>
                  </li>
                  <li>
                    <vs-radio  name="defaultBranch" @input="branchChanges(true)" :vs-value="true"  v-model="custBranchType" class="w-full" >Let the Customer choose</vs-radio>
                  </li>
                </ul>
                <input type="hidden" :name="'select_defaultBranch'" v-validate="'required'" data-vv-as="Field"  v-model="custBranchType">
                <span class="text-danger text-sm" 
                v-show="errors.has('newinvitepetitionerform.select_defaultBranch')">{{ errors.first('newinvitepetitionerform.select_defaultBranch')}}</span>
              </div>
              <div class="vx-col  w-full" v-if="[3].indexOf(getUserRoleId)>-1 && custBranchType == false">
                <div class="form_group">
                    <div class="con-select w-full select-large">
                      <label for="" class="form_label">Branch<em>*</em></label>
                      <multiselect name="branch" data-vv-as="Branch" v-validate="'required'" v-model="selectedBranch"
                            :show-labels="false" track-by="_id" label="name" placeholder="Select Branch" :options="branchList"
                            :searchable="true" :allow-empty="false" :multiple="false"
                            :disabled="false"
                            @input="formerrors.msg = ''" :key="'branch-branch'">
                          </multiselect>
                    </div>
                    <span class="text-danger text-sm"
                          v-if="errors.has('newinvitepetitionerform.branch')">{{ errors.first("newinvitepetitionerform.branch") }}</span>
                      <span class="text-danger text-sm" v-else-if="branchError">{{ branchError }}</span>
                    </div>
              </div>
              <template v-if="[3,50,51].indexOf(getUserRoleId)<=-1 && false">
                <vs-checkbox class="ml-0" v-model="custBranchType">Let the Customer choose Branch</vs-checkbox>
              </template>
            </template>
            <div class="text-danger text-sm formerrors" v-show="formerrors.msg">
              <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
                icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
            </div>
          </div>
          <div class="popup-footer">
            <button color="dark" @click="closenewPetPopup()" class="btn gray_btn mr-5" type="filled">Cancel</button>
            <button color="success" @click="petitionerInvite()" class="btn theme_btn" type="filled">Submit</button>
          </div>
         </form> 

</template>



<script>


import Datepicker from "vuejs-datepicker-inv";

import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from 'moment'
import PhoneMaskInput from "vue-phone-mask-input";
import * as _ from "lodash";
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';  
import Multiselect from "vue-multiselect-inv";

export default {
  
  components: {
    Multiselect,
    VuePhoneNumberInput,
    Datepicker,
    DateRangePicker,
    moment,
    PhoneMaskInput
  },
  data: () => ({
    custBranchType:null,
    callFromCapCaseCreation: false,
    disableOffice: false,
    branchError: '',  
    branchList: [],
    selectedBranch:null,
      createdNetitioner:null,
      isPetitionerPhoneValid:true,
    newPetitioner: {
        firstName: "",
        lastName:"",
        adminFirstName: "",
        adminLastName:"",
        roleId:50,
        email: "",
        phone:"",
        active:true,
        accountType: "Corporate",
        address: {
          "line1": "",
          "line2": "",
          "locationId": "",
          "stateId": "",
          "countryId": 231,
          "zipcode": ""
        }
      },
    count:0,
    vuePhone:{
        props:{
          translations:{
            phoneNumberLabel:"Phone Number"
          }
        }

      },

    formerrors: {
      msg: ""
    },
   
    saveBenbtn:false,
    

       
  }),
  watch: {
   
  },
  methods:{
    branchChanges(action){
        if(action){
          this.selectedBranch = null;
        }
      },


      getBranchList() {
      this.branchList = [];
      //  alert(JSON.stringify(this.searchtxt)) final_selected_statusids
      let item = {
        filters: {
          "title": '',
          "createdDateRange": [],
          "statusList": [],
          "activeList": [],
          "countryIds": [],
          "stateIds": [],
          "locationIds": []


        },
        getMasterData: true,
        page: 1,
        perpage: 1000,
        sorting: { "path": "createdOn", "order": -1 },

      };



      this.$store
        .dispatch("getList", { "data": item, "path": "/branch/list" })
        .then(response => {

          this.branchList = response.list;
          if (this.branchList.length == 1) {
            this.selectedBranch = this.branchList[0];
          }
        }).catch((error) => {
          this.branchList = [];
        })
    },

      closenewPetPopup(){
          this.$emit('closenewPetPopup' ,this.createdNetitioner )

      },

      updatePetitionerPhone(item) {
         
       this.isPetitionerPhoneValid =true;
      if (item.isValid) {
        
       this.newPetitioner.phoneCountryCode = {countryCode:item.countryCode,countryCallingCode:item.countryCallingCode};
       this.newPetitioner.phone = item.nationalNumber;
       
      }else{
        this.isPetitionerPhoneValid =false;
      }
     },


       petitionerInvite() {
           this.createdNetitioner =null;
        Object.assign(this.formerrors, {  msg: ''  });
       
        this.$validator.validateAll('newinvitepetitionerform').then(result => {
          if (result && this.isPetitionerPhoneValid) {
            this.newPetitioner['custBranchType'] = this.custBranchType
            if([3].indexOf(this.getUserRoleId)>-1 && this.custBranchType == false ){
              if(this.checkProperty(this.branchList, 'length')>1){
                if(this.checkProperty(this.selectedBranch, '_id')){
                  this.newPetitioner['branchId'] = this.selectedBranch['_id'];
                }
              }else{
                this.newPetitioner['branchId'] = this.checkProperty(this.branchList[0], '_id');
              }
            }else if([3,50,51].indexOf(this.getUserRoleId)<=-1){
              this.newPetitioner['custBranchType'] = false
              this.newPetitioner['branchId'] = this.checkProperty(this.getUserData, 'branchId');
            }


            
            this.$store.dispatch("commonAction", {
              data:this.newPetitioner,
              path: "/auth/invite-petitioner",})
              .then(response => {
               
                if (response.error) {
                  Object.assign(this.formerrors, {
                    msg: response.error.message
                  });
                } else {
                  // let dat =  response['data'];
                  // dat['branchId'] = '6257fa6f621cbad27e2773a5'
                    this.createdNetitioner = response['data'];
                   this.showToster({message:response.data.message,isError:false});
                   this.closenewPetPopup();
                  
                }
               

                // this.$router.go('/beneficiaries');
              }).catch((err)=>{
                Object.assign(this.formerrors, {
                    msg: err
                  });

              })
          }
        });
      },
   
  },
  mounted() {
    if([3,50,51].indexOf(this.getUserRoleId)<=-1){
      this.custBranchType = false;
    }else{
      this.custBranchType = null;
    }
    this.getBranchList();
    this.count =0;
        
  }
};
</script>